const theme = {
  colors: {
    background: "rgba(51, 76, 125, 0.05)",
    primary: "#FE5000",
    textLight: "rgba(44, 49, 49, 0.8)",
    button: "#073B59",
  },
};

export default theme;
